import gql from 'graphql-tag';

export const WhyFundrisePageQuery = gql`
	query WhyFundrisePage {
		allWhyFundrisePage {
			_id
			whyFundriseIsDarkTheme
			whyEyebrow
			whyTitle
			whyDiagramSubtext
			whyDiagramVideo {
				asset {
					url
				}
			}
			whyDiagramVideoMobile {
				asset {
					url
				}
			}
			whyDiagramAnimation {
				asset {
					url
				}
			}
			whyDiagramAnimationMobile {
				asset {
					url
				}
			}
			whyDiagramFallback {
				asset {
					url
					altText
				}
			}
			whyDiagramFallbackMobile {
				asset {
					url
					altText
				}
			}
			whyCards {
				toutHeading
				toutSummary
				toutCta {
					url
					linkText
					openInNewTab
				}
			}
			ourTechnologySection {
				panelHeading
				panelOverline
				sectionSummary
				sectionCards {
					image {
						asset {
							url
							altText
						}
					}
					heading
					title
					description
					link {
						url
						linkText
						openInNewTab
					}
				}
				isSectionDarkTheme
			}
			annualReturnsSnapshotEnabled
			snapshotTitle
			snapshotHeading
			snapshotDescription: snapshotDescriptionRaw
			snapshotTableHeading
			snapshotLinkUrl
			snapshotLinkText
			assetsImage {
				asset {
					url
					altText
				}
			}
			assetsHeading
			assetsTitle
			assetsDescription
			assetsLinkUrl
			assetsLinkText
			alignmentDarkTheme
			alignmentEyebrow
			alignmentTitle
			alignmentDescription
			alignmentCards {
				toutHeading
				toutSummary
				toutCta {
					url
					linkText
					openInNewTab
				}
			}
			ctaDarkTheme
		}
	}
`;
